// extracted by mini-css-extract-plugin
export var contrastLow = "_26-1";
export var externalLink = "_26-2";
export var externalLinkIcon = "_26-3";
export var link = "_26-0";
export var linkLabel = "_26-4";